export const isWriterOnlyAdmin = (user) => {
  const roles = user?.roles || [];

  if (!Array.isArray(roles) || roles.length === 0) {
    return false;
  }

  return roles.length === 1 && roles[0].name === 'AI Chat User';
};
